import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { fontWeight } from "@mui/system";

export const SelectSemesterAndYearStyles = muiStyled(Box)(({ selected }) => ({
    '.title': {
        padding: "7px 0px 7px 10px",
        fontWeight: "bold"
    },
    '.applied-button': {
        display: "flex",
        justifyContent: "end",
        padding: "5px 10px 10px 10px"
    }
}));

